import { render, staticRenderFns } from "./ModalRemoveItemFromForm.vue?vue&type=template&id=99f4bece&scoped=true"
import script from "./ModalRemoveItemFromForm.vue?vue&type=script&lang=js"
export * from "./ModalRemoveItemFromForm.vue?vue&type=script&lang=js"
import style0 from "./ModalRemoveItemFromForm.vue?vue&type=style&index=0&id=99f4bece&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f4bece",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99f4bece')) {
      api.createRecord('99f4bece', component.options)
    } else {
      api.reload('99f4bece', component.options)
    }
    module.hot.accept("./ModalRemoveItemFromForm.vue?vue&type=template&id=99f4bece&scoped=true", function () {
      api.rerender('99f4bece', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/forms/ModalRemoveItemFromForm.vue"
export default component.exports